import axios from 'axios'
import {CreateInstance} from './config'
const remoteSessionAPI = CreateInstance('remote_session', 'launcher')
const versionAPI = CreateInstance('/lmmviewer/version.html', 'download')
const launcherPrepareAPI = CreateInstance('prepare', 'launcher')

// 접속·파일전송 클릭 시 백엔드에서 단기 JWT(5분 만료) 발급받음.
// 이 JWT는 fallback 다운로드 URL의 ?param=<JWT>에 박혀 파일명으로 전달되고,
// launcher가 설치 후 자기 파일명에서 JWT를 추출해 /launcher/start로 검증한다.
// action: 'RC'(원격접속) | 'FT'(파일전송), devicePk: Device.pk
const prepareLauncher = (action, devicePk) =>
  launcherPrepareAPI.post('', {action, device_pk: devicePk}).then(res => res.data.jwt)
const launcherAPI = (guid, cb) => {
  return axios.all([remoteSessionAPI.get(guid), versionAPI.get('')])
    .then(axios.spread((sessionResp, versionResp) => {
      if (sessionResp.data.status !== 200) return cb(sessionResp.data.status)
      const session = sessionResp.data.objects[0]
      const version = versionResp.data
      cb(null, {session, version})
    }))
    .catch(err => {
      cb(err)
    })
}
export {remoteSessionAPI, versionAPI, prepareLauncher}
export default launcherAPI
